
import { Component, Vue, Prop } from "vue-property-decorator";

import program_routes from "@/api/routes/programs";

@Component({
  name: "VConstructorNew"
})
export default class VConstructorNew extends Vue {
  @Prop({ required: true }) public id!: string;

  public title: string = "";
  public title_errors: boolean = false;

  private create_in_progress: boolean = false;

  protected created() {
    this.$store.commit("factoryProgramId", this.id);
  }

  public async createProgram() {
    if (this.create_in_progress) {
      return;
    }

    this.create_in_progress = true;
    this.title_errors = false;

    const title = this.title.trim();

    if (!title.length) {
      return this.showError("Введите название программы");
    }

    return this.$api
      .post(program_routes.edits, {
        title,
        factory_id: this.id
      })
      .then(async ({ data: res }: { data: { id: string } }) => {
        this.$router.push({
          name: "constructor_programs_edit",
          params: { id: res.id }
        });
      })
      .catch(({ response: res }) => {
        this.showError(res.data.error);
      });
  }

  private showError(message: string) {
    this.title_errors = true;
    this.create_in_progress = false;

    this.$notify({
      group: "notifications",
      type: "error",
      text: message,
      duration: 500,
      speed: 500
    });
  }
}
